import clsx from "clsx"
import {Children, cloneElement, forwardRef, isValidElement, useState} from "react"
import Radio, {RadioProps} from "./Radio"
import "./RadioGroup.css"

interface RadioGroupProps extends React.HTMLAttributes<HTMLDivElement> {
    label?: string | undefined
    vertical?: boolean | undefined
    children?: Array<React.ReactElement<RadioProps>> | React.ReactElement<RadioProps> | undefined
    invalid?: boolean | undefined
    name: string
}

const RadioGroup: React.FC<RadioGroupProps> = forwardRef<HTMLDivElement, RadioGroupProps>((props, ref) => {
    const {label, name, invalid, vertical = false, className, children, ...otherProps} = props
    const [selected, setSelected] = useState<string>("")

    const radioButtons = Children.map(children, child => {
        if (!isValidElement<RadioProps>(child)) return
        const radioButton = child as React.ReactElement<RadioProps>
        if (radioButton.type !== Radio) return
        const result = cloneElement(radioButton, {
            invalid: invalid,
            selected: selected === radioButton.props.value,
            onSelect: setSelected,
            name: name,
        })
        return result
    })

    return (
        <div
            ref={ref}
            className={clsx(
                "radio-group-w2zx",
                invalid ? "invalid-w2zx" : "",
                vertical ? "vertical-w2zx" : "",
                className,
            )}
            {...otherProps}
        >
            <span className="label-w2zx">{label}</span>
            <div className="radio-buttons-w2zx">{radioButtons}</div>
        </div>
    )
})

export default RadioGroup
